/* eslint-disable react/prop-types */
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { resetWorkerPin } from "services";
import { useTranslation } from "react-i18next";

const PinAccess = (props) => {
  const { t } = useTranslation();
  const { onPinAccessSuccess, onCancel, showPinAccess, worker } = props;
  const [pin, setPin] = useState("");
  const [newPin, setNewPin] = useState("");
  const [newConfirmPin, setNewConfirmPin] = useState("");
  const [error, setError] = useState();
  const [isNewPinModalVisible, setIsNewPinModalVisible] = useState(false);
  const [newPinModalError, setNewPinModalError] = useState();
  const [isNewPinContinueDisabled, setIsNewPinContinueDisabled] = useState(true);
  const theme = useTheme();

  useEffect(() => {
    if (showPinAccess) {
      setError(null);
      setPin("");

      if (!worker.pin) {
        setNewPin("");
        setNewConfirmPin("");
        setIsNewPinModalVisible(true);
        setNewPinModalError(null);
      }
    }
  }, [showPinAccess]);

  useEffect(() => {
    if (newPin.length === 0 && newConfirmPin.length === 0) {
      setIsNewPinContinueDisabled(true);
    } else {
      setIsNewPinContinueDisabled(false);
    }
  }, [newPin, newConfirmPin]);

  const isValidPin = () => {
    if (worker.pin === pin) {
      setError(null);
      if (onPinAccessSuccess) onPinAccessSuccess();
    } else {
      setError(t("other.errIncorrectPIN"));
    }
  };

  const isNewPinValid = () => {
    if (newPin === newConfirmPin && newPin.length === 3) {
      setNewPinModalError(null);
      resetWorkerPin(worker.workerId, newPin);
      setIsNewPinModalVisible(false);
      if (onPinAccessSuccess) onPinAccessSuccess(true);
    } else {
      if (newPin.length < 3 || newConfirmPin.length < 3){
        setNewPinModalError(t("other.errIncorrectNewPinLength"))
      } else if (newPin !== newConfirmPin) {
        setNewPinModalError(t("other.errNewPINsDontMatch"))
      }
    }
  };

  const pinModal = (
    <Dialog open={showPinAccess} maxWidth="xs" fullWidth>
      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          isValidPin();
        }}
      >
        <DialogTitle>{t("other.txtEnterPIN")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
          {t("other.txtEnterPINMessage")}
          </DialogContentText>
          <TextField
            name="pin"
            autoFocus
            fullWidth
            placeholder={t("other.txtEnterPIN")}
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            error={error ? true : false}
            helperText={error}
          />
        </DialogContent>
        <Box
          component={DialogActions}
          style={{
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            paddingBottom: theme.spacing(2),
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              if (onCancel) onCancel();
            }}
          >
            {t("general.cancelBtn")}
          </Button>
          <Button
            type="submit"
            variant="contained"
            disableElevation
            color="primary"
            disabled={!pin}
          >
            {t("other.btnContinueActivity")}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );

  const newPinModal = (
    <Dialog open={showPinAccess} maxWidth="xs" fullWidth>
      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          isNewPinValid();
        }}
      >
        <DialogTitle>{t("other.txtSetNewPINMessage")}</DialogTitle>
        <DialogContent>
          <TextField
            name="newPin"
            autoFocus
            fullWidth
            placeholder={t("other.txtEnterPIN")}
            value={newPin}
            onChange={(e) => {
              if (!isNaN(e.target.value)) {
                setNewPin(e.target.value);
              }
            }}
            inputProps={{ maxLength: 3 }}
          />
          <TextField
            name="newConfirmPin"
            fullWidth
            placeholder={t("other.txtReEnterPIN")}
            value={newConfirmPin}
            onChange={(e) => {
              if (!isNaN(e.target.value)) {
                setNewConfirmPin(e.target.value);
              }
            }}
            inputProps={{ maxLength: 3 }}
            error={newPinModalError ? true : false}
            helperText={newPinModalError}
          />
        </DialogContent>
        <Box
          component={DialogActions}
          style={{
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            paddingBottom: theme.spacing(2),
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              if (onCancel) onCancel();
            }}
          >
            {t("general.cancelBtn")}
          </Button>
          <Button
            type="submit"
            variant="contained"
            disableElevation
            color="primary"
            disabled={isNewPinContinueDisabled}
          >
            {t("other.btnContinueActivity")}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );

  return isNewPinModalVisible ? newPinModal : pinModal;
};

export default PinAccess;
